import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { AppComponent } from './app.component';
import { ErrorInterceptor } from './helpers/error-interceptor';
import { appInitializer } from './helpers/initializer';
import { JwtInterceptor } from './helpers/jwt-interceptor';
import { ComponentBase } from './infrastructure/component-base';
import { LOGIN_DECLARATIONS } from './login';
import { SecurityService } from './services/security.service';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AuthBase } from './helpers/authBase';
import { LazyLoaderService } from './helpers/lazy-loader';
import { ROUTES } from '@angular/router';
import { LAZY_WIDGETS } from './helpers/tokens';
import { lazyWidgets, lazyArrayToObj } from './helpers/lazy-widgets';
import { UploadInterceptor } from './helpers/UploadInterceptor';
import { LoaderInterceptor } from './helpers/loader-interceptor';
import { RenderReportComponent } from './render-report/render-report.component';
import { DecodeQrComponent } from './decode-qr/decode-qr.component';
import { API_BASE_URL_PROVIDER } from './core/api/api-tokens';
import { ICON_SETTINGS } from '@progress/kendo-angular-icons';

@NgModule({
  declarations: [AppComponent,
    LOGIN_DECLARATIONS,
    ComponentBase,
    AuthBase,
    RenderReportComponent,
    DecodeQrComponent],
  imports: [

    HttpClientModule,
    BrowserModule,
    CommonModule,
    IndicatorsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule
  ],
  providers: [
    API_BASE_URL_PROVIDER,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
      deps: [SecurityService],
    },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: UploadInterceptor, multi: true },
    { provide: LAZY_WIDGETS, useFactory: lazyArrayToObj },
    LazyLoaderService,
    { provide: ROUTES, multi: true, useValue: lazyWidgets },
    { provide: ICON_SETTINGS, useValue: { type: 'font' } }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
